import * as fromDatatype from "../datatype-library/index";

export interface bl_tpy_innovatif_user_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  tenant_guid: fromDatatype.GuidDataFieldInterface;
  tenant_branch_guid: fromDatatype.GuidDataFieldInterface;
  entity_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  journey_id: fromDatatype.GuidDataFieldInterface;
  okay_id_image_string: fromDatatype.TextDatatypeInterface;
  okay_id_image_format: fromDatatype.VarcharDatatypeInterface;
  okay_id_image_enabled: boolean;
  okay_id_face_image_enabled: boolean;
  okay_face_liveness_detection: boolean;
  okay_face_verification: boolean;
  okay_live_verification: boolean;
  verification_status: fromDatatype.VarcharDatatypeInterface;
  okay_doc_type: fromDatatype.VarcharDatatypeInterface;
  okay_doc_country: fromDatatype.VarcharDatatypeInterface;
  okay_doc_half_size_passport_img_b64: fromDatatype.TextDatatypeInterface;
  okay_doc_full_size_passport_img_b64: fromDatatype.TextDatatypeInterface;
  okay_doc_non_passport_id_img_b64: fromDatatype.TextDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_tpy_innovatif_user_hdr_RowClass
  implements bl_tpy_innovatif_user_hdr_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  tenant_guid: fromDatatype.GuidDataFieldInterface;
  tenant_branch_guid: fromDatatype.GuidDataFieldInterface;
  entity_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  journey_id: fromDatatype.GuidDataFieldInterface;
  okay_id_image_string: fromDatatype.TextDatatypeInterface;
  okay_id_image_format: fromDatatype.VarcharDatatypeInterface;
  okay_id_image_enabled: boolean;
  okay_id_face_image_enabled: boolean;
  okay_face_liveness_detection: boolean;
  okay_face_verification: boolean;
  okay_live_verification: boolean;
  verification_status: fromDatatype.VarcharDatatypeInterface;
  okay_doc_type: fromDatatype.VarcharDatatypeInterface;
  okay_doc_country: fromDatatype.VarcharDatatypeInterface;
  okay_doc_half_size_passport_img_b64: fromDatatype.TextDatatypeInterface;
  okay_doc_full_size_passport_img_b64: fromDatatype.TextDatatypeInterface;
  okay_doc_non_passport_id_img_b64: fromDatatype.TextDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
